import type { ReactNode } from "react";
import { motion, useReducedMotion } from "motion/react";

type Props = {
  children: ReactNode;
  className?: string;
};

/**
 * Quick opacity-only entrance for mobile screen bodies. Used for the Catalog
 * (Products / Categories) segment swap, where the header stays put and only
 * the body changes — a pure crossfade reads as a tab switch, whereas the
 * standard PageTransition slide-up reads as content "flying in" on every tap.
 */
export function MobileFade({ children, className }: Props) {
  const reduceMotion = useReducedMotion();
  if (reduceMotion) {
    return <div className={className}>{children}</div>;
  }
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.22, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}
